export default "__VITE_ASSET__BfMEfiRP__"